import { Grid, ListItemText, MenuItem, MenuList, Chip, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import SideNavItem from './sideNavItem';

const allText = 'All';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex'
  },
  menu: {
    maxWidth: 250,
    textAlign: 'start',
    minWidth: 180
  },
  menuItem: {
    justifyContent: 'start',
    alignContent: 'start',
    alignItems: 'start',
    margin: 0
  }
}));

const SideNav = (props) => {
  const classes = useStyles();

  const filter = (value) => {
    if (props.folders?.size > 0) {
      if (value === allText) {
        props.setData([...props.folders.values()].flatMap((s) => s));
        props.setFolderKey(allText);
      } else {
        props.setFolderKey(value);
      }
    }
  };

  return (
    <>
      {(
        <Box sx={{ display: 'flex', mb: 2 }}>
          <Chip
            label={`${allText} (${(props.allLength) || 0})`}
            clickable
            sx={(() => {
            const base = {
              cursor: 'pointer',
              mr: 2,
              bgcolor: 'transparent',
              '& .MuiChip-label': {
                fontWeight: 400,
                fontSize: '1rem',
                color: '#2F54A5',
                lineHeight: '1.5rem',
                fontFamily: 'Noto Sans, sans-serif',
                fontStyle: 'normal',
                borderRadius: '1.5rem',
                border: '1px solid #2F54A5',
                bgcolor: 'transparent',
                padding: '0.3rem 1rem'
              }
            };
            if (props.folderKey !== allText) return base;
            return {
              ...base,
              bgcolor: 'rgba(47, 84, 165, 0.20)',
              '& .MuiChip-label': {
                fontWeight: 600,
                fontSize: '1rem',
                color: '#2F54A5',
                lineHeight: '1.5rem',
                fontFamily: 'Noto Sans, sans-serif',
                fontStyle: 'normal',
                borderRadius: '1.5rem',
                border: '1px solid #2F54A5',
                bgcolor: 'rgba(47, 84, 165, 0.20)',
                padding: '0.3rem 1rem'
              }
            };
          })()}
            onClick={() => filter(allText)}
          />
          {props?.folders?.size > 0 &&
            [...props.folders.values()].map((item) => {
              return (
                <SideNavItem
                  key={'side-nav-item-' + item[0]?.reptSource}
                  item={item}
                  filter={filter}
                  total={item?.length ?? ''}
                  folderKey={props.folderKey}
                />
              );
            })}
          </Box>
    )}
    </>
  );
};
export default SideNav;
